exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.infobox-link-faq[data-v-d79beb4e] {\n  color: #455a64;\n  background-color: white;\n}\n.infobox-link-faq[data-v-d79beb4e]:hover {\n  color: #455a64;\n  text-decoration: none;\n}\n.infoboxFaq[data-v-d79beb4e]:hover{\n  background-color: lightgray;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d79beb4e","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboard/Dashboard.vue
// module id = FBSP
// module chunks = 1